var map = {
	"./CentOS 7.svg": 89253,
	"./Debian 11.svg": 1229,
	"./DirectAdmin.svg": 14170,
	"./Ubuntu 22.04.svg": 36329,
	"./Windows Server 2022.svg": 61308,
	"./Windows Server.svg": 14594,
	"./alma-linux.svg": 18910,
	"./astra-linux.svg": 76016,
	"./cPanel.svg": 88869,
	"./free-bsd.svg": 61428,
	"./plesk.svg": 72001,
	"./rocky-linux.svg": 13391,
	"./ubuntu.svg": 13155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60202;